import { render, staticRenderFns } from "./ReferalCode.vue?vue&type=template&id=1f3270ea&scoped=true&"
import script from "./ReferalCode.vue?vue&type=script&lang=ts&"
export * from "./ReferalCode.vue?vue&type=script&lang=ts&"
import style0 from "./ReferalCode.vue?vue&type=style&index=0&id=1f3270ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f3270ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCardTitle,VCol,VDialog,VRow})
